import DS from 'ember-data';
import SqlImportModel from 'cio/models/sql-import';
import Route from 'cio/routes/base';
import { hash } from 'rsvp';
import { ImportType, SqlImportDatabase } from 'cio/utils/sql-import';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import SqlImportsNewController from './controller';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';
import { IdentifierKey, ObjectIdentifierKey } from 'cio/utils/identifiers';

export default class SqlImportsNew extends Route {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Create Sync',
      path: 'sql-imports.new',
    };
  }

  async model({ id }: { id?: number }) {
    let { type } = this.paramsFor('sql-imports') as { type: SqlImportDatabase };
    let segments = await this.store.findAll('short-segment');
    let sqlImport: SqlImportModel =
      id != null
        ? await this.store.findRecord('sql-import', id)
        : this.store.createRecord('sql-import', {
            idFieldName: !this.environment.current.canIdentifyByEmail ? 'id' : null, // If the workspace is id only, set the `idFieldName` to id automatically.
            databaseType: type,
          });

    if (id != null && sqlImport.isDraft) {
      sqlImport.setProperties({
        databaseType: sqlImport.databaseType ?? type,
        idFieldName:
          sqlImport.idFieldName ??
          (sqlImport.importType === ImportType.Object ? ObjectIdentifierKey.ObjectId : IdentifierKey.Id),
      });
    }

    let sqlImportDatabases = await this.store.query('sql-import-database', { type });

    return hash({
      type,
      sqlImport,
      sqlImportDatabases,
      segments: segments.filterBy('isManual', true),
    });
  }

  setupController(controller: SqlImportsNewController, model: Record<string, any>, transition: Transition) {
    super.setupController(controller, model, transition);

    this.confirmChanges.register(controller, this);
  }

  resetController(controller: SqlImportsNewController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }
}
